<div class="text-center" style="margin-bottom: 20px">
  <h2 translate>components.signInModalComponent.creaCuenta</h2>
  <p translate>components.signInModalComponent.obtenAcceso</p>
</div>

<div class="content-modal" [formGroup]="registerForm">
  <div class="input-inv">
    <label for="first_name" translate
      >components.signInModalComponent.nombre</label
    >
    <input
      class="form-control"
      id="first_name"
      formControlName="first_name"
    />
    <div class="field-errors" *ngIf="registerForm.get('first_name')?.invalid && registerForm.get('first_name')?.touched">
      <small *ngIf="registerForm.get('first_name')?.errors?.['required']">El nombre es obligatorio</small>
      <small *ngIf="registerForm.get('first_name')?.errors?.['pattern']">Solo se permiten letras, números y espacios</small>
      <small *ngIf="registerForm.get('first_name')?.errors?.['maxlength']">Máximo 30 caracteres</small>
    </div>
  </div>
  <div class="input-inv">
    <label for="last_name" translate
      >components.signInModalComponent.apellidos</label
    >
    <input
      class="form-control"
      id="last_name"
      formControlName="last_name"
    />
    <div class="field-errors" *ngIf="registerForm.get('last_name')?.invalid && registerForm.get('last_name')?.touched">
      <small *ngIf="registerForm.get('last_name')?.errors?.['required']">El apellido es obligatorio</small>
      <small *ngIf="registerForm.get('last_name')?.errors?.['pattern']">Solo se permiten letras, números y espacios</small>
      <small *ngIf="registerForm.get('last_name')?.errors?.['maxlength']">Máximo 30 caracteres</small>
    </div>
  </div>
  <div class="input-inv">
    <label for="email" translate
      >components.signInModalComponent.tuEmail</label
    >
    <input
      type="email"
      class="form-control"
      id="email"
      formControlName="email"
    />
    <div class="field-errors" *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
      <small *ngIf="registerForm.get('email')?.errors?.['required']">El correo es obligatorio</small>
      <small *ngIf="registerForm.get('email')?.errors?.['email']">Ingresa un correo válido</small>
      <small *ngIf="registerForm.get('email')?.errors?.['minlength']">Mínimo 5 caracteres</small>
      <small *ngIf="registerForm.get('email')?.errors?.['maxlength']">Máximo 50 caracteres</small>
    </div>
  </div>
  <div class="input-inv" *ngIf="!isSocialSignup">
    <label for="password" translate
      >components.signInModalComponent.contrasena</label
    >
    <div class="password-container">
      <input
        [type]="showPassword ? 'text' : 'password'"
        class="form-control"
        id="password"
        formControlName="password"
      />
      <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="togglePasswordVisibility.emit()"></i>
    </div>

    <div class="password-checklist">
      <small [class.valid]="hasMinLength" [class.pending]="!hasMinLength">
        <i [ngClass]="hasMinLength ? 'fas fa-check-circle' : 'far fa-circle'"></i> Min. 8 caracteres
      </small>
      <small [class.valid]="hasUpperCase" [class.pending]="!hasUpperCase">
        <i [ngClass]="hasUpperCase ? 'fas fa-check-circle' : 'far fa-circle'"></i> 1 Mayúscula
      </small>
      <small [class.valid]="hasLowerCase" [class.pending]="!hasLowerCase">
        <i [ngClass]="hasLowerCase ? 'fas fa-check-circle' : 'far fa-circle'"></i> 1 Minúscula
      </small>
      <small [class.valid]="hasNumber" [class.pending]="!hasNumber">
        <i [ngClass]="hasNumber ? 'fas fa-check-circle' : 'far fa-circle'"></i> 1 Número
      </small>
    </div>
  </div>

  <div class="field-errors" *ngIf="emailAlreadyExists">
    <small>
      Ya tienes una cuenta con este email.
      <a (click)="openLoginModal.emit()" translate
        >components.signInModalComponent.entrar</a
      >
    </small>
  </div>

  <button
    id="btn_signin_step_1_next"
    (click)="continueClicked.emit()"
    [disabled]="!canContinue || checkingEmail"
    class="submit-btn"
  >
    <span translate>components.signInModalComponent.continuar</span>
  </button>
</div>

<div class="text-center" style="margin-top: 20px">
  <p class="text-thin">
    {{ "components.signInModalComponent.aceptarCondiciones" | translate }}
    <a (click)="goToLegal.emit()" translate
      >components.signInModalComponent.condiciones</a
    >
  </p>
  <p class="text-thin">
    {{ "components.signInModalComponent.yaTienesCuenta" | translate }}
    <a (click)="openLoginModal.emit()" translate
      >components.signInModalComponent.entrar</a
    >
  </p>
</div>
